import { FunctionComponent } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styled from 'styled-components';
import Modal, { ModalSize } from '../../../components/Modal';

const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledImageContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
`;

interface RosterModalProps {
    open: boolean;
    close: () => void;
}

const RosterModal: FunctionComponent<RosterModalProps> = ({ open, close }) => {
    const handleClose = () => {
        close();
    };

    const renderCloseButton = () => (
        <StyledButtonContainer>
            <IconButton onClick={handleClose}>
                <CloseIcon />
            </IconButton>
        </StyledButtonContainer>
    );

    const renderRosterPreview = () => (
        <StyledImageContainer>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{`first_name`}</TableCell>
                            <TableCell>{`last_name`}</TableCell>
                            <TableCell>{`email`}</TableCell>
                            <TableCell>{`role`}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{`John`}</TableCell>
                            <TableCell>{`Smith`}</TableCell>
                            <TableCell>{`john_smith@example.com`}</TableCell>
                            <TableCell>{`student`}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{`Patricia`}</TableCell>
                            <TableCell>{`Harris`}</TableCell>
                            <TableCell>{`patricia_harris@example.com`}</TableCell>
                            <TableCell>{`student`}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </StyledImageContainer>
    );

    return (
        <Modal isOpen={open} onClose={handleClose} size={ModalSize.Large}>
            {renderCloseButton()}
            {renderRosterPreview()}
        </Modal>
    );
};

export default RosterModal;
